import { RaRecord, useChoicesContext } from 'react-admin';
import { useFormContext } from 'react-hook-form';

import { AutocompleteInput, AutocompleteInputProps } from './AutocompleteInput';

/**
 * Эта обёртка над AutocompleteInput, которая при выборе значения копирует данные
 * выбранной записи в другие поля формы (например, id в основное поле, а name в `merchantName`).
 *
 * Зачем нужен.
 *
 * ReferenceInput рассчитан на то, что в поле формы лежит id.
 * Если подставить в optionValue другое поле (например, name),
 * запись находится только пока она попадает в (perPage={100}).
 * Если запись не найдена, подпись выбранного значения пропадает и поле выглядит пустым.
 *
 * @example
 * <ReferenceInput reference="merchants" source="merchant">
 *  <SyncedAutocompleteInput optionText="name" syncFields={{ merchantName: 'name' }} />
 * </ReferenceInput>
 */
export type AutocompleteInputSyncedProps = AutocompleteInputProps & {
  // { поле формы: ключ записи }, например { merchantName: 'name' }
  syncFields?: Record<string, string>;
};

export const AutocompleteInputSynced: React.FC<AutocompleteInputSyncedProps> = ({
  syncFields = {},
  onChange,
  ...props
}) => {
  const { setValue } = useFormContext();
  const { allChoices } = useChoicesContext({ choices: props.choices });
  const optionValue = props.optionValue ?? 'id';

  const handleChange = (value: any, record?: RaRecord | '') => {
    console.log('record', record);
    const selected = record || allChoices?.find((choice) => choice[optionValue] === value);

    Object.entries(syncFields).forEach(([field, recordKey]) => {
      setValue(field, selected ? selected[recordKey] : '', { shouldDirty: true });
    });

    onChange?.(value, selected || '');
  };

  return <AutocompleteInput {...props} onChange={handleChange} />;
};
